module.exports = __webpack_public_path__ + "media/images/ui__infoOk-c4cd8da33b42d7ea9ad862efe8c9b688.png";